import { render } from "./Puncture_force_chart.vue?vue&type=template&id=453b0ca2&scoped=true"
import script from "./Puncture_force_chart.vue?vue&type=script&lang=js"
export * from "./Puncture_force_chart.vue?vue&type=script&lang=js"

import "./Puncture_force_chart.vue?vue&type=style&index=0&id=453b0ca2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453b0ca2"]])

export default __exports__